import React from "react";
import ReactDOM from "react-dom";
import Routes from "./routes/Routes";
import { ConnectedRouter } from "connected-react-router";
import "./scss/index.scss";
import { Provider } from "react-redux";
import store from "./redux/store";
import history from "./redux/history";
import "regenerator-runtime/runtime";

// Provisional fix: Eslint thinks we are on React 18+ but we are on 16.9.x
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>{Routes}</ConnectedRouter>
    </Provider>,
    document.getElementById("app")
);
